import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/crm/product/getAll',
    method: 'get'
  })
}

export function getPage(condition, pagination) {
  return request({
    url: '/crm/product/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function getPagePopup(condition, pagination) {
  return request({
    url: '/crm/product/pagePopup',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}
export function getClientProductPopup(condition, pagination) {
  return request({
    url: '/crm/product/pageClientProductPopup',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/crm/product/saveOrUpdate',
    method: 'post',
    data
  })
}

export function get(id) {
  return request({
    url: '/crm/product/get',
    method: 'get',
    params: { id }
  })
}

export function deleteById(id) {
  return request({
    url: '/crm/product/deleteById',
    method: 'post',
    data: { id: id }
  })
}

export function deleteBatchByIds(ids) {
  return request({
    url: '/crm/product/deleteBatchById',
    method: 'post',
    data: { ids: ids }
  })
}

export function exportExcel(condition, pagination) {
  return request({
    url: '/crm/product/exportExcel',
    method: 'post',
    data: { condition: condition, pagination: pagination },
    responseType: 'blob'
  })
}

